"use strict";
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisitedPlaceDecorator = void 0;
const react_1 = __importDefault(require("react"));
const DateTimeUtils_1 = require("chaire-lib-common/lib/utils/DateTimeUtils");
const i18n_config_1 = __importDefault(require("../../config/i18n.config"));
/**
 * Frontend decorator for VisitedPlace that adds display and formatting methods
 * This decorator wraps a VisitedPlace instance and provides additional methods
 * that are only available in the frontend and can use i18n functionality.
 */
class VisitedPlaceDecorator {
    constructor(visitedPlace) {
        this.visitedPlace = visitedPlace;
    }
    /**
     * Get the visited place description
     * @param withTimes Whether to add the times to the description
     * @param allowHtml Whether the description can contain HTML characters
     * @returns Formatted description string or JSX element
     */
    getDescription(withTimes = false) {
        let times = '';
        if (withTimes) {
            const startTime = this.visitedPlace.startTime !== undefined
                ? ' ' + (0, DateTimeUtils_1.secondsSinceMidnightToTimeStr)(this.visitedPlace.startTime)
                : '';
            const endTime = this.visitedPlace.endTime !== undefined
                ? ' -> ' + (0, DateTimeUtils_1.secondsSinceMidnightToTimeStr)(this.visitedPlace.endTime)
                : '';
            times = startTime + endTime;
        }
        const activityLabel = i18n_config_1.default.t(`survey:visitedPlace:activities:${this.visitedPlace.activity}`);
        if (this.visitedPlace.name) {
            // Return JSX element when HTML is requested and name exists
            return (react_1.default.createElement("span", null,
                activityLabel,
                " \u2022 ",
                react_1.default.createElement("em", null, this.visitedPlace.name),
                times));
        }
        else {
            // Return plain string
            const nameLabel = this.visitedPlace.name ? ` • ${this.visitedPlace.name}` : '';
            return `${activityLabel}${nameLabel}${times}`;
        }
    }
    /**
     * Get formatted start time string
     * @returns Formatted start time or empty string if not set
     */
    getFormattedStartTime() {
        return this.visitedPlace.startTime !== undefined
            ? (0, DateTimeUtils_1.secondsSinceMidnightToTimeStr)(this.visitedPlace.startTime)
            : '';
    }
    /**
     * Get formatted end time string
     * @returns Formatted end time or empty string if not set
     */
    getFormattedEndTime() {
        return this.visitedPlace.endTime !== undefined ? (0, DateTimeUtils_1.secondsSinceMidnightToTimeStr)(this.visitedPlace.endTime) : '';
    }
}
exports.VisitedPlaceDecorator = VisitedPlaceDecorator;
//# sourceMappingURL=VisitedPlaceDecorator.js.map